/**
 * Cliente de API tipado (docs/09 §3.1 + contratos de `@zapir/shared`).
 *
 * Toda resposta de erro passa por `parseApiError`, que mapeia `code` -> copy
 * PT-BR + acao da tabela unica `ERROR_CODES` (RF-UX-059). Nenhuma copy de erro
 * e hardcoded nas telas.
 *
 * Os envelopes (paginação/coleções) e os nomes de campo são EXATAMENTE os do
 * `@zapir/shared` (contrato canônico). O refresh de sessão é transparente
 * (D-14): 401 dispara `POST /auth/refresh` uma vez e repete a requisição.
 *
 * Este arquivo é só o barril: o núcleo de request mora em `./api/core` e cada
 * grupo de endpoint em `./api/<dominio>`. O caminho de import público não muda
 * — as telas continuam fazendo `import { api } from "@/lib/api"`.
 */
import { authApi } from "./api/auth";
import { channelsApi } from "./api/channels";
import { conversationsApi } from "./api/conversations";
import { labelsApi } from "./api/labels";
import { mediaApi } from "./api/media";
import { messagesApi } from "./api/messages";
import { notificationsApi } from "./api/notifications";
import { realtimeApi } from "./api/realtime";
import { reportsApi } from "./api/reports";
import { searchApi } from "./api/search";
import { teamApi } from "./api/team";

export { authHeaders } from "./api/core";
export { timelineMessage, type NotificationView, type Page, type TimelineMessage } from "./api/types";

export type { ConnectResult, ConversationBoard, InviteInfo, Label, Member, PushDiagnostics, RealtimeTicket, SearchResults, SlaReport } from "@zapir/shared";

/** Objeto unico do cliente: um grupo de endpoints por dominio. */
export const api = {
  ...authApi,
  ...conversationsApi,
  ...messagesApi,
  ...searchApi,
  ...labelsApi,
  ...teamApi,
  ...channelsApi,
  ...mediaApi,
  ...notificationsApi,
  ...realtimeApi,
  ...reportsApi,
};
